import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite';
import { Paper, FontIcon, RadioButton } from 'material-ui';
import RaisedButton from '../../tc-ui/raised-button-with-loader';
import AddItemCard from '../../contracting/generic-components/add-item-card/AddItemCard';
import { countries, currencies } from '../../../utils/select-fields';
import Select from 'react-select';

const styles = StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' },
  ruleBox: {
    padding: '24px 0',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0',
  },
  countryCurrencyBox: {
    minWidth: '185px',
    display: 'flex',
    flexDirection: 'column',
  },
  countryCurrencyBoxSelected: {
    minWidth: '185px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    bottom: '12px',
  },
  radioGroup: {
    padding: '0 4px',
  },
  country: {
    width: '250px',
  },
  currency: {
    width: '250px',
  },
  tcTypes: {
    width: '450px',
  },
  tpCode: {
    border: '1px solid #e0e0e0',
    padding: '0 8px',
    width: '200px',
    fontSize: '12px',
    height: '32px',
    borderRadius: '3px',
  },
});
const IntegrationNotesSettings = props => {
  const {
    /*
    notesSettings = [{ code: '', tcTypes: ['', ''] }]
    */
    notesSettings = [],
    updateSettings,
    saveSettings,
    savingSettings,
    enableNotesSettingSaveButton,
    triggerSnackBarMessage,
  } = props;
  console.log(notesSettings)
  const updatePCS = newArray => updateSettings({
    notesSettings: newArray,
    enableNotesSettingSaveButton: true,
  });
  const addOne = () => updatePCS([...notesSettings, {
    code: '',
    tcTypes: [],
  }]);
  const removeNote = i => () => updatePCS(R.remove(i, 1, notesSettings));
  const selectTCTypes = index => (values) => updatePCS(R.update(
    index,
    { ...notesSettings[index], tcTypes: values.map(v => v.value) },
    notesSettings,
  ));
  const updateNoteCode = index => ({ target: { value } }) => updatePCS(R.update(
    index,
    { ...notesSettings[index], code: value },
    notesSettings,
  ));
  const save = () => {
    saveSettings({
      notesSettings: notesSettings,
    }, { enableNotesSettingSaveButton: false })
      .catch(() => {
        triggerSnackBarMessage('Unable to save notes settings.');
        updateSettings({ savingNotesSettingsError: true, enableNotesSettingSaveButton: true });
      });
  };
  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <FontIcon className="tc-icon-bulb" color="#ffc800" style={{ fontSize: '24px' }} />
        <div style={{ display: 'inline-block', width: '90%', marginLeft: '2%' }}>
          You can configure the notes categories that your texts will be exported with by adding a setting here.
        </div>
      </div>
      <div className={css(styles.container)}>
        <Paper style={{ marginTop: '24px', minHeight: '100px' }}>
          <div className={css(styles.header)}>Product Notes Setting</div>
          <br/>
          <div style={{ marginLeft: '16px' }}>
            {
              notesSettings.map((rule, i) => (
                <div className={css(styles.ruleBox)} key={i}>
                  <b>Note Category {i + 1}:</b>&nbsp;
                  Export content of&nbsp;&nbsp;
                  <div className={css(styles.tcTypes)}>
                    <Select
                      name="TourConnect Text Types"
                      placeholder="TourConnect Text Types (you can select more than one)"
                      scrollMenuIntoView={false}
                      options={[
                        { value: 'bedsAndSofas', label: 'Bedding Configuration' },
                        { value: 'cancelPolicy', label: 'Cancellation Policy' },
                        { value: 'childPolicy', label: 'Child Policy' },
                        { value: 'infantPolicy', label: 'Infant Policy' },
                        { value: 'pickup', label: 'Pickup/Opening' },
                        { value: 'dropoff', label: 'Dropoff/Closing' },
                        { value: 'blackoutDates', label: 'Blackout Dates' },
                      ]}
                      clearable={false}
                      multi
                      value={rule.tcTypes.join(',')}
                      onChange={selectTCTypes(i)}
                    />
                  </div>
                  &nbsp;to&nbsp;
                  <input
                    value={rule.code}
                    placeholder="Note code from Tourplan"
                    onChange={updateNoteCode(i)}
                    className={css(styles.tpCode)}
                  />.&nbsp;&nbsp;
                  <RaisedButton
                    label="Remove Note"
                    primary
                    style={{ marginLeft: '12px', width: '130px' }}
                    onTouchTap={removeNote(i)}
                  />
                </div>
              ))
            }
            {
              Boolean(notesSettings.length) && <br/>
            }
            <AddItemCard
              onClick={addOne}
              color="#00bcd4"
              text="Add note category"
            />
            <br/>
          </div>
          <RaisedButton
            label={enableNotesSettingSaveButton ? 'Save' : 'Saved'}
            secondary
            loader={savingSettings}
            disabled={!enableNotesSettingSaveButton}
            style={{ margin: '12px 80%', width: '130px' }}
            onTouchTap={save}
          />
        </Paper>
      </div>
    </div>
  );
};

const mapPropsToState = ({ integration }) => ({
  savingNotesSettingsError: integration.getIn(['settings', 'savingNotesSettingsError']),
  savingSettings: integration.getIn(['settings', 'savingSettings']),
  enableNotesSettingSaveButton: integration.getIn(['settings', 'enableNotesSettingSaveButton']),
  notesSettings: integration.getIn(['settings', 'notesSettings']) ? integration.getIn(['settings', 'notesSettings']).toJS() : [],
});

export default connect(mapPropsToState)(IntegrationNotesSettings);



// WEBPACK FOOTER //
// ./src/app/components/integration/settings/notes-settings.jsx